export default __webpack_public_path__ + "static/media/My_Highlights_page_empty_2_360x256.fdfdc795.png";